import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Label, Row,} from 'reactstrap';

import {
    APPROVE_MSG,
    ARE_YOU_SHURE_TITLE,
    error,
    LIST,
    NO,
    REJECT_MSG,
    saveMsg,
    success,
    YES_CONFIRM,
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import {
    ButtonAccept,
    ButtonClean,
    ButtonReject,
    ButtonSearch,
    ButtonTableEdit,
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import Select from "react-select";
import {modelsProvider} from "../../../providers/modelsProvider";
import {toDoTaskService} from "../../../jwt/_services/profile/toDoTaskService";
import DatePicker from "react-datepicker";
import {useForm} from "react-hook-form";
import {employeeProvider} from "../../../providers/employeeProvider";
import {utilHelper} from "../../../jwt/_helpers";

const ToDoTaskList = (props) => {
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [disableEmployee, setDisableEmployee] = useState(true);
    const [, setViewButtons] = useState(false);
    const [date, setDate] = useState(null);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [department, setDepartment] = useState(null);
    const [modelOptions, setModelOptions] = useState([]);
    const [model, setModel] = useState(null);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [employee, setEmployee] = useState(null);
    const actionOptions = [
        {id: 'CREATE', value: 'CREATE', label: 'CREATE'},
        {id: 'UPDATE', value: 'UPDATE', label: 'UPDATE'},
        {id: 'DELETE', value: 'DELETE', label: 'DELETE'}
    ]
    const [action, setAction] = useState(null);
    const statusOptions = [
        {id: 'PENDING', value: 'PENDING', label: 'PENDING'},
        {id: 'DONE', value: 'DONE', label: 'DONE'},
        {id: 'EDITED', value: 'EDITED', label: 'EDITED'},
        {id: 'REJECTED', value: 'REJECTED', label: 'REJECTED'}
    ]
    const [status, setStatus] = useState({id: 'PENDING', value: 'PENDING', label: 'PENDING'});
    const [dataFilter, setDataFilter] = useState({
        model: null,
        action: null,
        status: 'PENDING',
        employee: null,
        registerDate: null
    });

    useEffect(() => {
        // setLoading(true);
        //
        // modelsProvider.getOptions()
        //     .then(result => {
        //         if (result)
        //             setModelOptions(result);
        //     })
        //     .catch( console.log )
        //     .finally( () => setLoading(false) );
    }, []);

    useEffect( () => {
        // setLoading(true);
        //
        // //List all my department by supervisor
        // employeeProvider.findAllMyDepartmentSupervisor()
        //     .then(result => {
        //         if (result)
        //             setDepartmentOptions(result);
        //     })
        //     .catch( console.log )
        //     .finally( () => setLoading(false) )
    },[])

    useEffect( () => {
        refreshDataList(page, currentIndex, sizePerPage, dataFilter);
    },[])

    const getEmployesByDepartment = (id) => {
        setLoading(true);
        employeeProvider.getEmployesByDepartment({id})
            .then(result => {
                if (result) {
                    setDisableEmployee(false);
                    setEmployeeOptions(result);
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);
            });
    };

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage, dataFilter);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, dataFilterP) => {
        setLoading(true);
        setDataFilter(dataFilterP);

        toDoTaskService.search(currentIndex, sizePerPage, dataFilterP)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);

                    if (status?.id === 'PENDING' && result?.total > 0)
                        setViewButtons(true);
                    else
                        setViewButtons(false);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
            })
            .catch(errorMessage => {
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            })
            .finally( () => setLoading(false) );
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        setLoading(true);

        const dataRequest = {
            model: model?.value,
            action: action?.value,
            status: status?.value,
            employee: employee?.id,
            registerDate: utilHelper.dateFormatter(date)
        };

        refreshDataList(page, currentIndex, sizePerPage, dataRequest);
    };

    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.beginEdit(itemToEdit);
    }

    const cleanFields = () => {
        setLoading(true);
        reset();
        setModel(null);
        setAction(null);
        setStatus(null);
        setDepartment(null);
        setEmployee(null);
        setDate(null);
        setViewButtons(false);

        const dataRequest = {
            model: null,
            action: null,
            status: null,
            employeeId: null,
            registerDate: null
        };
        setDataFilter(dataRequest);
        refreshDataList(page, currentIndex, sizePerPage, dataRequest);
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------

    const onActionChange = (value) => setAction(value);

    const onStatusChange = (value) =>  setStatus(value);

    const onModelChange = (value) => setModel(value);

    const onDepartmentChange = (value) => {
        setDepartment(value);
        getEmployesByDepartment(value.id);
    }

    const onEmployeeChange = (value) => setEmployee(value);

    const actionsFormatter = (cell, row) => <ButtonTableEdit onClick={() => editItem(row)}/>

    const dateFormatter = (cell) => utilHelper.dateFormatter(cell)

    const statusFormatter = (cell, data) => {
        let status = data['status'];
        let classNameStatus = "center-block padding-5 label " + status;

        return <span className={classNameStatus}>{status}</span>
    }

    const getDataRequest = (listItemsP) => {
        let listResult = [];

        listItemsP.map(item => {
            listResult.push({id: item.idTask});
        })

        return listResult;
    }

    const approve = () => {
        setLoading(true);
        const dataRequest = getDataRequest(listItems);

        return toDoTaskService.approveAll(dataRequest)
            .then(_ => {
                showToastCustom(success, saveMsg);
                props.toggleParent();
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const reject = () => {
        setLoading(true);
        const dataRequest = getDataRequest(listItems);

        return toDoTaskService.rejectAll(dataRequest)
            .then(_ => {
                showToastCustom(success, saveMsg);
                props.toggleParent();
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmApprove = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{APPROVE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            approve().then(_ => {
                            })
                            onClose();
                        }}>
                            {YES_CONFIRM}
                        </button>
                    </div>
                );
            }
        });
    }

    const confirmReject = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{REJECT_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            reject().then(_ => {
                            })
                            onClose();
                        }}>
                            {YES_CONFIRM}
                        </button>
                    </div>
                );
            }
        });
    }

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'idTask',
            headerStyle: {width: '0px'},
            text: 'ID_Tarea',
            hidden: true
        }, {
            dataField: 'registerDate',
            text: "Fecha de registro",
            formatter: dateFormatter
        }, {
            dataField: 'name',
            text: 'Nombre',
            formatter: (cell, row) => <span> {row?.name}  {row?.lastName} </span>
        },  {
            dataField: 'action',
            text: 'Acción',
        }, {
            dataField: 'model',
            text: 'Modelo',
            sort: true
        }, {
            dataField: 'status',
            text: 'Estado',
            headerAlign: 'center',
            align: 'center',
            formatter: statusFormatter
        }, {
            dataField: 'operationDate',
            text: "Fecha de Operación",
            headerAlign: 'center',
            align: 'center',
            formatter: dateFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    {/*<Col md="2">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>Modelo</Label>*/}
                    {/*        <Select name="model"*/}
                    {/*                value={model}*/}
                    {/*                options={modelOptions}*/}
                    {/*                placeholder="Modelo"*/}
                    {/*                isSearchable={true}*/}
                    {/*                isClearable={true}*/}
                    {/*                onChange={onModelChange}/>*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    {/*<Col md="2">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>Acción</Label>*/}
                    {/*        <Select options={actionOptions}*/}
                    {/*                value={action}*/}
                    {/*                placeholder="Acción"*/}
                    {/*                isClearable={true}*/}
                    {/*                onChange={onActionChange}/>*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    <Col md="2">
                        <FormGroup>
                            <Label>Status</Label>
                            <Select options={statusOptions}
                                    value={status}
                                    placeholder="Status"
                                    isClearable={true}
                                    onChange={onStatusChange}/>
                        </FormGroup>
                    </Col>
                    {/*<Col md="2">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>Departamento</Label>*/}
                    {/*        <Select name="department"*/}
                    {/*                value={department}*/}
                    {/*                options={departmentOptions}*/}
                    {/*                placeholder="Selecciona una opción"*/}
                    {/*                isSearchable={true}*/}
                    {/*                isClearable={true}*/}
                    {/*                onChange={onDepartmentChange}/>*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    {/*<Col md="2">*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>Empleado</Label>*/}
                    {/*        <Select name="employee"*/}
                    {/*                value={employee}*/}
                    {/*                options={employeeOptions}*/}
                    {/*                placeholder="Selecciona una opción"*/}
                    {/*                isSearchable={true}*/}
                    {/*                isClearable={true}*/}
                    {/*                isDisabled={disableEmployee}*/}
                    {/*                onChange={onEmployeeChange}/>*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    <Col md="2">
                        <FormGroup>
                            <Label>Fecha de registro</Label>
                            <br/>
                            <DatePicker
                                dateFormat={"dd/MM/yyyy"}
                                showMonthDropdown={true}
                                showYearDropdown={true}
                                scrollableYearDropdown={false}
                                selected={date}
                                onChange={date => setDate(date)}
                                isClearable
                                placeholderText="Fecha de registro"
                                className="form-control"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
        <CardBody className="">
            {loading && showLoader()}
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listItems}
                    columns={columns}
                    pagination={paginationFactory({page, sizePerPage, totalSize})}
                    onTableChange={handleTableChange}
                />
        </CardBody>
    </Card>
}

export default ToDoTaskList